import styled from 'styled-components/macro';
import { breakPoints } from '../../../config/config';
import {
  darkerGray,
  gradientBlue,
  newGrayVariant,
  newRed,
} from '../../../config/colors';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 35px 20px 0 20px;

  @media (max-width: ${breakPoints.tabletWidth}px) {
    padding: 25px 15px;
  }
`;

export const LogoWrapper = styled.div`
  text-align: center;
  margin-bottom: 30px;
  & img {
    width: 160px;
    height: auto;
  }
`;

export const InnerWrapper = styled.div`
  width: ${({ width }) => (width ? `${width}px` : '460px')};
  margin: 35px 20px 0 20px;

  @media (max-width: ${breakPoints.tabletWidth}px) {
    width: 100%;
    margin: 15px 0 0 0;
  }
`;

export const Form = styled.form`
  border-radius: 10px;
  box-shadow: 0px 2px 10px #37465f26;
  padding: 42px;
  background-color: white;
  @media (max-width: ${breakPoints.tabletWidth}px) {
    padding: 25px 20px;
  }
`;

export const Title = styled.h1`
  color: ${darkerGray};
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 5px;
  margin-top: 0;
  line-height: normal;
  margin-bottom: 30px;
  max-width: 370px;
  margin-left: auto;
  margin-right: auto;
  word-break: break-word;

  @media (max-width: ${breakPoints.tabletWidth}px) {
    font-size: 23px;
  }
`;

export const SubTitle = styled.h2`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  max-width: 350px;
  text-align: center;
  word-break: break-word;
  margin: 0 auto;
  padding-bottom: ${({ paddingBottom }) => paddingBottom ?? '40px'};
  color: ${darkerGray};
`;

export const CtaWrapper = styled.div`
  width: 100%;
  display: flex;
  padding-top: 40px;
  flex-direction: column;
  position: relative;

  button {
    width: 100%;
    height: 50px;
    &:disabled {
      background: ${newGrayVariant};
      border-color: ${newGrayVariant};
      cursor: not-allowed;
    }
  }

  div {
    right: 0;
    left: auto;
    top: calc(50% + 20px);
  }
`;

export const StyledLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  color: ${gradientBlue};
`;

export const ErrorWrapper = styled.div`
  background-color: ${newRed};
  color: white;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 15px;
  border-radius: 5px;
`;
